import React from "react";
import { Badge } from "react-bootstrap";
import { ArrowDownUp } from "react-bootstrap-icons";

const ItemTitle = ({ item }) => {
  return (
    <React.Fragment>
      {item.displayName}
      {" - "}
      <span className="h6">
        <ArrowDownUp size={16}/>
        {(item.suggestedSalesPrice - item.minSalesPrice).toFixed(2)}
      </span>
      <p className="h6 fw-normal text-muted">{item.secondaryDisplayName}</p>
    </React.Fragment>
  );
};

export default ItemTitle;
